@use "../../../../scss/settings/colors";

.page_title {
  text-transform: capitalize;
  color: colors.$base-black;
  font-size: 26px;
}

.document_header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .actions_group {
    display: flex;
    align-items: center;
    gap: 16px;
    transform: translateY(8px);
  }
}

.tabs {
  :global(.MuiTab-root) {
    text-transform: none;
    padding: 8px 16px;
    color: colors.$text-black-3;
    font-size: 14px;
    border-radius: 6px;
    //margin: 0 4px;
    transition: color 0.2s ease, background-color 0.2s ease;

    &:hover {
      color: colors.$brand-purple;
     // background-color: colors.$light-purple;
    }

    &:global(.Mui-selected) {
      color: colors.$brand-purple;
      font-weight: 500;
      //background-color: colors.$light-purple;
    }
  }

  :global(.MuiTabs-indicator) {
    background-color: colors.$brand-purple;
  }
}

.tab_container {
  margin-bottom: 15px;

  .tabs_section {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
  }
}

.upload_container {
  position: relative;
  width: fit-content;

  .upload_form {
    position: absolute;
    top: 0;
    left: 100%;
    margin-left: 8px;
    z-index: 1000;
    background-color: colors.$base-white;
    width: 430px;
    height: 165px;
  }
}

.form_box {
  margin-left: 8px;
  position: absolute;
  z-index: 1005;
  animation: pulse 0.5s ease-in-out;
  border-color: colors.$brand-purple;
  top: 4rem;
}

.form_upload{
  border-color: colors.$brand-purple;
  margin-left: 32px;
}


.card_list_view_container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 5px 8px;
  background-color: colors.$gray-variant-21;
  border-radius: 8px;
  border: 1px solid colors.$gray-variant-4;
}

.variant_btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 3px 6px;
  font-family: 'Medium Inter', sans-serif;
  font-size: 12px;
  text-transform: none;
  color: colors.$dark-blue;
  background-color: transparent;
  border-color: transparent;
  border-radius: 10px;
  transition: color 0.3s, background-color 0.3s;

  &[disabled]{
    opacity: 0.5;
  }

  &.variant_btn_active, &:hover {

    &:not([disabled]) {
      color: colors.$base-white;
      background-color: colors.$purple-light-5;
    }

  }

  svg {
    width: 16px;
    height: 16px;
    fill: currentColor !important;
  }

}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
